var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.crumbs)?_c('BBreadcrumb',{attrs:{"items":_vm.crumbs}}):_vm._e(),_c('Transition',[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }